import { render } from "./weekdayController.vue?vue&type=template&id=d8720266&scoped=true"
import script from "./weekdayController.vue?vue&type=script&lang=js"
export * from "./weekdayController.vue?vue&type=script&lang=js"

import "./weekdayController.vue?vue&type=style&index=0&id=d8720266&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8720266"]])

export default __exports__